require('../../../corporate-template/js/feature/two-section-grid.js');